var _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#0E1621"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 32,
    height: 32,
    fill: "url(#pattern0_1168_161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1168_161",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1168_161",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1168_161",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC+0lEQVR4nO2cz27TQBDGLQ5IUC6AxAVeAakHEEKCB6Ac+h7AgyD+SUCrFI48BOJBIjjXtXe+MYZWCiBBQUZbBdRD3SiJ4xnb308aKXK88c5OMmvvfpkkIYQQQgghhBBCCCGkp5R7e9dU5BFEPgD4pMC3aPF1PBbfi+dY97N3pGl6CcBLiBwqUJ1mEPkDkXcicsW6370ghHBTgWLWwJ9gGtta97/TFHl+FyKTBQb/369hoqp3rP3oJFmWXYaILDr4x4IQYgqz9qdzqMiLZQf/v4k8s/anU4zH47MKfKkZ0J8AngC4nuf5+WjxdTwW36tpU8bPtParMwDYrEknv4sQ7tW1K0LYiHdBJ7YFNtv1IkmS6bdjGyIHjf2cLU1kNMtnFXmz5JyxD2ArTdNzSwdARXbMBw3NmYjcmuUzgNsNBXtnqcGvquqMAj96FoC1WX7Hcxq63vc4hgwA5guAql5wEYCjzjAFVaucb2YSJxIAr+PEYp0+tKW8rCJvl7kGgK8AXjUyCff0NnSjrl0hct/VbWhvH8REnqrqepwTjiZd1fV4DCK/atrwQWxeVOR5U6krBmfuDgydrLnFuPxgd/eitT+dpOBytJsNGV3gjgmfQ7hh3f8+bUk+PmW183jKOYzrQdySXAFlWV5VkYcA3k834ifTHbOP8ZiG8CCes4prE0LIUKEgyggKogyhIMoQPoEaQkGUMRREGUJBlDG9EUR5oTFhVguCKHViLoVZrQqi4MQ8CbNaFkRVTsyPMKtlQVTlxPwIswaagkaJG2FWC4IodWKmwiwKooyhIMoBFEQZQ0GUA7gc7QAKohxAQZQTKIgihBDSNiUrZNmQskKWHYEVsuwo+JckOzJWyLJFWSHLjjErZNmCvgrCOl8xS9oXhLkUZlmZWKoxPAmzDAOwZigI8yPM8hwAXZ0gzI8wa6ApaJQkQ6+YJe0LwgZZMQuskGXLmBWy7FFWyLIlY4UsewouR9sTWCHLnpQVsnxQskIWIYQQQgghhBBCCEl88Bda4BaNRd8nBgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/FiltersIcon.4526a42830e23da89fd01bc80870e302.svg";
export { ForwardRef as ReactComponent };